import { render, staticRenderFns } from "./show.vue?vue&type=template&id=696b881d&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=696b881d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696b881d",
  null
  
)

export default component.exports